import * as React from 'react'
import s from './styles.module.css'
// libs
import { motion } from 'motion/react'
// components
import Glow from '../../../../glows'
import LearnMoreButton from '../../../../ui/LearnMoreButton'
import AnimatedContainer from '../../../../ui/AnimatedContainer/animatedContainer'
// views
import {
  titleAnimation,
  subtitleAnimation,
} from '../../../../../constants/animation'
// assets
import { ReactComponent as PodAlumniScene } from '../../../../../assets/imgs/alumni/pod-alumni.svg'
import { ReactComponent as CheckIcon } from '../../../../../assets/imgs/recruting/feather-check.svg'

const POD_ALUMNI_DATA = [
  `Allow parents, students and alumni to feel the true value of your school's network`,
  'Deliver a gift to your alumni that they will value and enjoy exploring',
  'Turn your alumni directory into an experience that will professionally benefit both students and alumni',
]

const useAnimateNumber = (
  ids,
  target,
  duration,
  delay = 0,
  formatter = (v) => `${v}%`
) => {
  React.useEffect(() => {
    const els = ids.map((id) => document.getElementById(id)).filter(Boolean)
    if (!els.length) return

    let raf = null
    const timeout = setTimeout(() => {
      let start = null

      const step = (ts) => {
        if (start === null) start = ts
        const progress = Math.min((ts - start) / duration, 1)
        const value = Math.floor(progress * target)
        els.forEach((el) => {
          el.textContent = formatter(value)
        })
        if (progress < 1) {
          raf = requestAnimationFrame(step)
        }
      }

      raf = requestAnimationFrame(step)
    }, delay)

    return () => {
      clearTimeout(timeout)
      if (raf) cancelAnimationFrame(raf)
    }
  }, [ids, target, duration, delay, formatter])
}

const PodAlumniSection = () => {
  useAnimateNumber(['_98_text_dark', '_98_text_light'], 98, 2000, 0)
  useAnimateNumber(['_95_text_dark', '_95_text_light'], 95, 2000, 250)
  useAnimateNumber(['_86_text_dark', '_86_text_light'], 86, 2000, 500)

  return (
    <section className='alumni-content'>
      <div className='box'>
        <Glow position='right' />

        <AnimatedContainer
          className={`alumni-grid-container ${s.gridExt}`}
          mountOnEnter
        >
          <div className={s.leftContent}>
            <motion.p
              className='recruiting-main-title'
              variants={titleAnimation}
            >
              Pod Alumni
            </motion.p>
            <motion.p
              className='recruiting-sub-content-container'
              variants={subtitleAnimation}
            >
              {POD_ALUMNI_DATA.map((text, index) => (
                <div key={index} className='recruiting-sub-content'>
                  <div className='recruiting-sub-content-icon'>
                    <CheckIcon />
                  </div>
                  <div>{text}</div>
                </div>
              ))}
            </motion.p>
            <div className='recruiting-button-container'>
              <LearnMoreButton />
            </div>
          </div>
          <div className={s.section}>
            <PodAlumniScene />
          </div>
        </AnimatedContainer>
      </div>
    </section>
  )
}

export default PodAlumniSection
